<div class="steps">
  <div
    class="step"
    *ngFor="let item of stepsData"
    [ngClass]="{ active: item === step }"
  ></div>
</div>
